export const BASIC_TEMPLATE_FIELDS = `
  agents {
    nodes {
      id
    }
  }
  conditions {
    nodes {
      id
      param
      operator
      value
    }
  }
  createdAt
  default
  displayCountWhenInactive
  id
  locked
  matchType
  name
  position
  state
  teams {
    nodes {
      id
    }
  }
  channels {
    nodes {
      id
    }
  }
  updatedAt
  
`

export const query = folderId => `
  query FolderQuery {
    folders(id: "${folderId}") {
      ${BASIC_TEMPLATE_FIELDS}
    }
  }
`

export const collectionQuery = () => `
  query FoldersQueryV2($size: Int) {
    folders(first: $size) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`

export const dataTableQuery = () => `
  query FoldersDataTableQueryV2 {
    folders(first: 1000, filter: { state: ALL }) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    channels(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    agents(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    teams(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`
